export var Keys = function (obj) {
    return Object.keys(obj);
};
